import { createFileRoute } from '@tanstack/react-router'
import { LandingPage } from '@/components/landing/landing-page'
import {
  SITE_DESCRIPTION,
  SITE_NAME,
  organizationSchema,
  personSchema,
  seo,
  websiteSchema,
} from '@/shared/lib/seo'

export const Route = createFileRoute('/')({
  head: () => ({
    ...seo({
      title: `${SITE_NAME} — 1:1 AI coding workflow sessions`,
      description: SITE_DESCRIPTION,
      path: '/',
      // The share card leads with the hero line rather than the brand, because
      // that is the claim someone decides to click on.
      socialTitle:
        'The AI writes the code. Keeping it maintainable is still your job.',
      // Site-wide identity lives on the homepage only — Google consolidates
      // Organization to the home entity, so repeating it per page is noise.
      jsonLd: [organizationSchema, personSchema, websiteSchema],
    }),
  }),
  component: App,
})

function App() {
  return <LandingPage />
}
